var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ni-app-footer-wrapper columns is-centered is-half"},[_vm._v(" © "+_vm._s(_vm.currentYear)+" Thermo Fisher Scientific Inc. All Rights Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }